import {useState, useEffect} from "react";
import {
  ISectorDataFromServer,
  ITrendDataFromServer,
} from "../pages/Fintech/FintechDashboard.type";
import {getFintechTrendsCount} from "../helper/api";

const useFetchDataFintech = (
  apiUrlTrends: string,
  apiUrlSectors: string,
  apiKey: string
) => {
  const [trendsData, setTrendsData] = useState<ITrendDataFromServer | null>(
    null
  );
  const [sectorsData, setSectorsData] = useState<ISectorDataFromServer | null>(
    null
  );
  const [weakSignalsData, setWeakSignalsData] = useState<{
    data: any[];
    meta?: unknown;
  } | null>(null);
  const [weakSegmentsData, setWeakSegmentsData] = useState<{
    data: any[];
    meta?: unknown;
  } | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const trendsUrl = new URL(apiUrlTrends);
    const sectorsUrl = new URL(apiUrlSectors);
    const weakSignalsUrl = new URL(
      apiUrlTrends.replace(/\/api\/trends\/?$/, "/api/weak-signals")
    );
    const weakSegmentsUrl = new URL(
      apiUrlTrends.replace(/\/api\/trends\/?$/, "/api/weak-signal-segments")
    );

    trendsUrl.searchParams.set("populate", "*");
    trendsUrl.searchParams.set(
      "pagination[pageSize]",
      getFintechTrendsCount?.toString() || "100"
    );
    sectorsUrl.searchParams.set("populate", "*");
    weakSignalsUrl.searchParams.set("pagination[pageSize]", "200");
    weakSegmentsUrl.searchParams.set("pagination[pageSize]", "50");

    const optionalJson = (url: string) =>
      fetch(url, {headers}).then(async (response) => {
        if (!response.ok) return null;
        return response.json();
      });

    Promise.all([
      fetch(trendsUrl.href, {headers}).then((response) => response.json()),
      fetch(sectorsUrl.href, {headers}).then((response) => response.json()),
      optionalJson(weakSignalsUrl.href),
      optionalJson(weakSegmentsUrl.href),
    ])
      .then(([trendsData, sectorsData, weakSignals, weakSegments]) => {
        setTrendsData(trendsData);
        setSectorsData(sectorsData);
        setWeakSignalsData(weakSignals);
        setWeakSegmentsData(weakSegments);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrlTrends, apiUrlSectors, apiKey]);
  return {
    trendsData,
    sectorsData,
    weakSignalsData,
    weakSegmentsData,
    error,
  };
};

export default useFetchDataFintech;
